/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useCartEnabled from "../../Components/Cart/useCartEnabled";
import { LoginV3Data } from "../../Components/Utility/Utility";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { onFetchCartCount } from "../../Store/Slices/cartSlice";

// The cart icon shows for clients with the cart on, logged in or not.
export const useShowHeaderCart = () => useCartEnabled().isCartEnabled;

/* Refreshes the header count on every page change. The cart page is skipped
   because it loads the full cart itself. Used once, in HeaderOptimized. */
export const useHeaderCartRefresh = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const showCart = useShowHeaderCart();
  const isLogin = Boolean(sessionStorage.getItem("login"));
  const memberId = LoginV3Data()?.memberIdentifier;

  useEffect(() => {
    if (showCart && isLogin && memberId && pathname !== "/cart") {
      dispatch(onFetchCartCount({ memberId }));
    }
  }, [pathname, showCart, isLogin, memberId]);
};

/* Cart icon with the number of cart lines (each product + denomination counts
   once). Renders as a list item so it sits inside the header icon lists.
   Logged out: goes to sign in and comes back to /cart afterwards, using the same
   ProductListPage return path as the header login button. */
const HeaderCart = ({ className = "" }) => {
  const translation = getTranslationData();
  const isLogin = Boolean(sessionStorage.getItem("login"));
  const signInUrl = useSelector((state) => state.cardDataSliceReducer?.SignInUrl);
  const items = useSelector((state) => state.cartReducer?.items);
  const lineCount = isLogin ? items?.length || 0 : 0;

  const handleClick = (event) => {
    if (isLogin || !signInUrl) return;
    event.preventDefault();
    localStorage.setItem("ProductListPage", "/cart");
    localStorage.setItem("ProductListPage_back", window.location.pathname + window.location.search);
    window.location.href = signInUrl;
  };

  return (
    <li className={`header-cart-item ${className}`.trim()}>
      <Link
        to="/cart"
        className="header-cart"
        onClick={handleClick}
        aria-label={`${translation?.cartHeaderLabel}${lineCount > 0 ? ` (${lineCount})` : ""}`}
      >
        <span className="header-cart__icon" aria-hidden="true" />
        {lineCount > 0 && (
          <span className="header-cart__count" aria-hidden="true">
            {lineCount > 99 ? "99+" : lineCount}
          </span>
        )}
      </Link>
    </li>
  );
};

export default HeaderCart;
/* eslint-enable react-hooks/exhaustive-deps */
